import { createContext, useContext } from 'react';

// The permissions of the logged-in account (J/authority/Permission), as GET /api/me answers them:
// the admin and program guards provide the answer they decided on, so every screen below them can
// ask `useCan()('people.merge')` before it offers an action. The backend enforces every permission
// itself; hiding an action only spares a person a refusal.
//
// Outside a guard (a test that renders one screen on its own) the context is null and nothing is
// hidden.
export const PermissionsContext = createContext(null);

export const PERMISSIONS = {
  staffArea: 'staff.area',
  staffManage: 'staff.manage',
  programArea: 'program.area',
  programPublish: 'program.publish',
  programEditorsManage: 'program.editorsManage',
  peopleApplyDirectly: 'people.applyDirectly',
  peopleDelete: 'people.delete',
  peopleMerge: 'people.merge',
  peopleExport: 'people.export',
  eventsCreateDelete: 'events.createDelete',
  programImportApply: 'program.importApply',
  legalNoticeEdit: 'legalNotice.edit',
};

export const useCan = () => {
  const permissions = useContext(PermissionsContext);
  return (key) => permissions === null || permissions.includes(key);
};
